import { Box, Button } from "@adfenix/alexandria";
import { Modal } from "components/Modal";
import { useLocation } from "react-router-dom";

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  masqueradeUserEmail?: string;
}
export const MasqueradeModal = ({
  isModalOpen,
  closeModal,
  masqueradeUserEmail
}: Props) => {
  const { pathname } = useLocation();

  return (
    <Modal show={isModalOpen} onClose={closeModal}>
      <Modal.Card>
        <Modal.Card.Head onClose={closeModal}>
          <Modal.Card.Title>Success</Modal.Card.Title>
        </Modal.Card.Head>

        <Modal.Card.Body>
          <p>
            You are no longer masqueraded as <b>{masqueradeUserEmail}</b>.
          </p>
        </Modal.Card.Body>

        <Modal.Card.Foot style={{ justifyContent: "center" }}>
          <Box>
            <Button
              logLabel="masquerade-back-office-link-button"
              variant="primary"
              onClick={() => {
                window.location.replace(
                  window.location.href.replaceAll(pathname, "")
                );
              }}
            >
              Return to back-office
            </Button>
          </Box>
        </Modal.Card.Foot>
      </Modal.Card>
    </Modal>
  );
};
